module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    class: {
      mobile: _vm.mobile
    }
  }, [_c('a', {
    attrs: {
      "href": "http://refinery29.com",
      "target": "_blank"
    },
    on: {
      "click": _vm.logo_ga
    }
  }, [_c('img', {
    attrs: {
      "id": "nav_logo",
      "src": require("../assets/img/refinery29_logo.svg")
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "nav_social"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/refinery29",
      "target": "_blank"
    },
    on: {
      "click": _vm.nav_facebook_ga
    }
  }, [_c('svg', {
    staticClass: "nav_social_icon facebook",
    attrs: {
      "width": "36",
      "height": "36",
      "viewBox": "0 0 36 36",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Facebook Logo")]), _c('g', {
    attrs: {
      "transform": "translate(1 1)",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('ellipse', {
    attrs: {
      "stroke": "#E8BDC0",
      "cx": "16.875",
      "cy": "17",
      "rx": "16.875",
      "ry": "17"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.169 24.933V17H13.5v-2.734h1.669v-1.641c0-2.23.942-3.557 3.62-3.557h2.228v2.735h-1.393c-1.042 0-1.11.382-1.11 1.095l-.006 1.368h2.525L20.737 17h-2.229v7.934H15.17z",
      "fill": "#E8BDC0"
    }
  })])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/Refinery29",
      "target": "_blank"
    },
    on: {
      "click": _vm.nav_twitter_ga
    }
  }, [_c('svg', {
    staticClass: "nav_social_icon twitter",
    attrs: {
      "width": "36",
      "height": "36",
      "viewBox": "0 0 36 36",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('title', [_vm._v("Twitter Logo")]), _c('g', {
    attrs: {
      "transform": "translate(1 1)",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('ellipse', {
    attrs: {
      "stroke": "#E8BDC0",
      "cx": "16.875",
      "cy": "17",
      "rx": "16.875",
      "ry": "17"
    }
  }), _c('path', {
    attrs: {
      "d": "M25.41 10.462c-.67.41-1.41.707-2.2.866a3.404 3.404 0 0 0-2.527-1.128c-1.91 0-3.461 1.601-3.461 3.576 0 .28.03.553.09.815-2.878-.15-5.429-1.572-7.137-3.738a3.662 3.662 0 0 0-.469 1.8c0 1.24.611 2.335 1.54 2.976a3.38 3.38 0 0 1-1.569-.446v.044c0 1.733 1.194 3.18 2.779 3.507a3.35 3.35 0 0 1-1.564.063c.44 1.42 1.718 2.454 3.234 2.482A6.806 6.806 0 0 1 9 22.76a9.587 9.587 0 0 0 5.307 1.606c6.369 0 9.85-5.449 9.85-10.175 0-.156-.002-.311-.008-.464a7.134 7.134 0 0 0 1.726-1.85 6.742 6.742 0 0 1-1.988.562 3.566 3.566 0 0 0 1.523-1.978",
      "fill": "#E8BDC0"
    }
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-620d8fb3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/main-nav.vue
// module id = 51
// module chunks = 0